
import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import { getFirmwareList } from './firmware';
import intl from 'react-intl-universal';

message.config({
  top: 300,
  maxCount: 3
});

// 更新固件信息
export const UPDATE_FIRMWARE_DETAIL = "UPDATE_FIRMWARE_DETAIL";


// 新增固件
export function addFirmware(params={}) {
  return (dispatch, getState) => {
      const {
          pId,
          firmwareId
      }=params
    const data = {
        area: null,
        cnDevices: null,
        createTime: 1620748083000,
        effectiveDay: 0,
        firmwareId: firmwareId,
        firmwareLabel: "",
        firmwareLabelEn: "",
        firmwareType: "",
        firmwareUrl: "",
        firmwareVersion: "",
        grayRatio: 0,
        md5: "",
        moduleId: "",
        packageId:"",
        parameterConfig: null,
        productId: pId,
        publishStatus: 1,
        publishTime: null,
        publishType: null,
        recordId: null,
        releaseNotes: null,
        releaseNotesEn: null,
        remindType: null,
        serialProtocolUrl: "",
        size: 11243,
        updateTime: 1620748083000,
        usDevices: null,
        userId: ""
    }
    dispatch(updateFirmwareData(data));
  }
}

// 编辑已有的固件
export function editFirmware(value) {
  return (dispatch, getState) => {
    // const data = {
    //     area: null,
    //     cnDevices: null,
    //     createTime: 1620748083000,
    //     effectiveDay: null,
    //     firmwareId: 23,
    //     firmwareLabel: "自定义测试固件mcu",
    //     firmwareLabelEn: "test_firm_mcu",
    //     firmwareType: "zigbee",
    //     firmwareUrl: "ezviz-ota.cn-sh2.ufileos.com/df288d04ec4c4c099c673d132f56e727",
    //     firmwareVersion: "V1.2.7 build 20210511",
    //     grayRatio: value.grayRatio,
    //     md5: "df288d04ec4c4c099c673d132f56e727",
    //     moduleId: "1233",
    //     parameterConfig: null,
    //     productId: "GB7430679E20E44F4A5520",
    //     publishStatus: 1,
    //     publishTime: null,
    //     publishType: null,
    //     recordId: null,
    //     releaseNotes: null,
    //     releaseNotesEn: null,
    //     remindType: null,
    //     serialProtocolUrl: "",
    //     size: 11243,
    //     updateTime: 1620748083000,
    //     usDevices: null,
    //     userId: ""
    // }
        dispatch(updateFirmwareData(value));
    }
}

// 更新固件信息
export function updateFirmwareData(data) {
    return (dispatch, getState) => {
        const { firmwareDetail } = getState().firmwareEdit;
        const newData = Object.assign({}, firmwareDetail, data);
        dispatch({
        type: UPDATE_FIRMWARE_DETAIL,
        firmwareDetail: newData,
        });
    };
}

// 修改固件信息
export function saveFirmwareData(params,callback) {
    return (dispatch, getState) => {
        const { firmwareDetail } = getState().firmwareEdit;
        const url =params.isAdd === "add"? '/iot/config/api/iot/support/firmware/ota/add':'/iot/config/api/iot/support/firmware/ota/edit';
        const {
            firmwareId,
            pId,
          } = params;
        const fetchData = new FetchData(url, {
            method: "POST",
            body:params,
            metaHandler: {
            403: () => { window.location.href = '/authrization/login'; return; }
            },
        });
        fetchData
            .then(data => {
            if (data.code == '200') {
                dispatch(getFirmwareList({firmwareId,pId}))
                message.success(intl.get('commmon.operate.success'));
            } else {
                message.error(data.msg || intl.get('commmon.operate.retry'));
            }
            })
            .catch(e => {
            message.error(intl.get('commmon.operate.retry'));
        });
    };
}
// 验证或发布信息
export function saveFirmwareReleaseData(params,callback) {
    return (dispatch, getState) => {
        const { firmwareDetail } = getState().firmwareEdit;
        const url = '/iot/config/api/iot/support/firmware/ota/upgrade';
        const {
            firmwareId,
            pId,
          } = params;
          // 如果全量发布，则有效时间设置为 10年
          if(params.grayRatio === 100){
            params.effectiveDay = 3650;
          }
        const fetchData = new FetchData(url, {
            method: "POST",
            body:params,
            metaHandler: {
            403: () => { window.location.href = '/authrization/login'; return; }
            },
        });
        fetchData
            .then(res => {
            if (res.code == '200') {
                dispatch(getFirmwareList({firmwareId,pId}))
                const { data } = res
                const {
                    US,
                    China
                } = data
                if(US == 1 && China == 1){
                    callback && callback()
                    message.success(intl.get('home.product.firmwareUpgradeDetail.releaseSuccess'));
                }
                if(US == 0 && China == 0){
                    message.error(intl.get('home.product.firmwareUpgradeDetail.releaseError'));
                }
                if(US == 0){
                    callback && callback()
                    message.error(intl.get('home.product.firmwareUpgradeDetail.releaseErrorUS'));
                }
                if(US == 1){
                    callback && callback()
                    message.success(intl.get('home.product.firmwareUpgradeDetail.releaseSuccess'));
                }
                if(China == 0){
                    message.error(intl.get('home.product.firmwareUpgradeDetail.releaseErrorCN'));
                }
                if(China == 1){
                    callback && callback()
                    message.success(intl.get('home.product.firmwareUpgradeDetail.releaseSuccess'));
                }
                // if(data.US&&data.China){
                //     if(US == 0 && China == 0){
                //         message.error("发布失败"); 
                //     }else if(US == 1 && China == 0){
                //         message.error("北美区域发布失败");
                //         callback && callback() 
                //     }else if(US == 0 && China == 1){
                //         message.error("中国区域发布失败");
                //         callback && callback() 
                //     }else if(US == 1 && China == 1){
                //         callback && callback()
                //         message.success("发布成功"); 
                //     }
                // } 
                // if(data.US && !data.China){
                //     if(US == 1){
                //         callback && callback()
                //         message.success("发布成功"); 
                //     }
                //     if(US == 0 ){
                //         message.error("北美区域发布失败"); 
                //     }
                // }
                // if(data.US && !data.China){
                //     if(China == 1){
                //         callback && callback()
                //         message.success("发布成功"); 
                //     }
                //     if(China == 0){
                //         message.success("中国区域发布成功");
                //     }
                // }

            } else if (res && res.code == 60016) {
                message.error(res.msg);
            } else {
                message.error(intl.get('commmon.operate.retry'));
            }
            })
            .catch(e => {
            message.error(intl.get('commmon.operate.retry'));
        });
    };
}

// 验证完成
export function verificationComplete(params) {
    return (dispatch, getState) => {
        const { firmwareDetail } = getState().firmwareEdit;
        const url = `/iot/config/api/iot/support/firmware/ota/tested?pId=${params.pId}&firmwareId=${params.firmwareId}&firmwareVersion=${params.firmwareVersion}`;
        const body = {
            pId: params.pId,
            recordId: params.recordId,
        };
        const {
            firmwareId,
            pId,
          } = params;
        const fetchData = new FetchData(url, {
            method: "POST",
            // body,
            metaHandler: {
            403: () => { window.location.href = '/authrization/login'; return; }
            },
        });
        fetchData
            .then(data => {
            if (data.code === '200') {
                dispatch(getFirmwareList({firmwareId,pId}))
                message.success(intl.get('commmon.operate.success'));
            } else {
                message.error(data.msg || intl.get('commmon.operate.retry'));
            }
            })
            .catch(e => {
            message.error(intl.get('commmon.operate.retry'));
        });
    };
}
  
  